import { logOut } from "@/api/auth";
import { useQuery } from "react-query";
import { renderNotification } from "../notification/renderFunctions";

// Create IAM logout URL and redirect user after signout
const SignOut = () => {
  const { isLoading } = useQuery({
    queryKey: ["logout"],

    queryFn: () => logOut,

    onSuccess: () => {

      // IAM_V1
      // window.location.href =
      //   "https://signin.test.access.pwc.com/openam/XUI/?realm=%2Fventuressso#logout";

      // localStorage.removeItem("id_token");

      // IAM_V2
      // console.log("IAM V2 logout triggered");
      const tenantId = import.meta.env.VITE_IAM_V2_PIAM_TENANT_ID;
      const logoutBaseUrl = import.meta.env.VITE_IAM_V2_PIAM_LOGOUT_URL;
      const redirectUri = import.meta.env.VITE_IAM_V2_PIAM_LOGOUT_REDIRECT_URL;

      const logoutUrl =
        `${logoutBaseUrl}/${tenantId}/oauth2/v2.0/logout` +
        `?post_logout_redirect_uri=${encodeURIComponent(
          redirectUri
        )}`;

        console.log("Logout URL:", logoutUrl);

      localStorage.removeItem("id_token");
      localStorage.removeItem("next_refresh");

      window.location.href = logoutUrl;
    },

    onError: (err) => {
      renderNotification(err, "error");
    },
  });

  if (isLoading) {
    return <div>Logging out...</div>;
  }

  return <div>You have signed out.</div>;
};

export default SignOut;